import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import Image from "~/components/Image";

import transition from "~/utilities/transition";

const ImageWrapper = styled.div`
    ${transition({}, "background-color", "border")};
    border-radius: 3px;
    background-color: white;
    display: block;
    width: 45px;
    height: 45px;
    overflow: hidden;

    border: ${({ isActive }) =>
        isActive ? `2px solid rgba(0 0 0 / 0.5)` : `2px solid transparent`};
    background-color: ${({ theme, isActive }) =>
        isActive
            ? theme.colors.backgroundColor.defaultLight
            : theme.palette.white};

    &:hover,
    &:focus {
        cursor: pointer;
        background-color: ${({ theme }) => theme.palette.grayFive};
        border: 2px solid rgba(0 0 0 / 0.25);
    }
`;

const CarouselImage = styled(Image)`
    ${transition({}, "opacity")};
    display: block;
    width: 43px;
    height: 43px;

    &:hover,
    &:focus {
        opacity: 1;
    }

    img {
        opacity: ${({ isActive }) => (isActive ? `1` : `0.5`)};
        &:hover,
        &:focus {
            opacity: 1 !important;
        }
    }
`;

const ProductCarouselImage = ({ image, isActive = false }) => (
    <ImageWrapper {...{ isActive }}>
        {image && (
            <CarouselImage {...image} {...{ isActive }} objectFit="contain" />
        )}
    </ImageWrapper>
);

ProductCarouselImage.propTypes = {
    image: PropTypes.shape({
        sourceUrl: PropTypes.string.isRequired,
        altText: PropTypes.string,
        title: PropTypes.string.isRequired,
        slug: PropTypes.string,
    }).isRequired,
    isActive: PropTypes.bool,
};

export default ProductCarouselImage;
